import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'


import StripeThankYou from './StripeThankYou.vue'
declareVconsoleComponent('stripeThankYou', StripeThankYou, 'stripe:thank_you:page')